import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { adminService } from '../../../../core/services'
import * as interfaces from '../../../../static/interfaces'
import * as Hooks from '../../../../utils/hooks'
import { Button } from '../../../atoms'
import AdminLayoutIndex from '../_layouts'
import { Container, Draggable } from 'react-smooth-dnd'
import arrayMove from 'array-move'
import * as constants from '../../../../static/constants'
import SvgIcon from 'components/atoms/SvgIcon'

declare var window: interfaces.IWindow

interface IProps {
  tags: {
    tags: IJsonResponse
  }
}

const AdminTagIndex: React.FC<IProps> = props => {
  Hooks.SetDocumentTitle('Admin tags')

  const { data, pagination } = adminService.getDataFromJson(props.tags.tags)
  const [tags, setTags] = React.useState(data)

  const onDrop = ({ removedIndex, addedIndex }) => {
    setTags(old => arrayMove(old, removedIndex, addedIndex))
  }

  const onSubmit = () => {
    updateTagsOrder()
  }

  const updateTagsOrder = React.useCallback(async () => {
    const tags_ids = tags.map(item => {
      return item.id
    })
    const { updatedTags, flush } = await adminService.updateTags(tags_ids)
    window.flashMessages.addMessage({ text: flush.message, type: flush.type })
    location.href = '/admin/tags'
  }, [tags])

  const handleDelete = React.useCallback(
    async id => {
      const response = await adminService.deleteTag(id)
      // TODO 成功レスポンスと揃えたい
      window.flashMessages.addMessage({
        text: response.data.flush.message,
        type: response.data.flush.type,
      })
      setTags(tags.filter(tag => tag.id !== id))
    },
    [tags]
  )

  const handleClickDelete = id => {
    if (window.confirm(I18n.t('generic.delete_confirmation'))) {
      handleDelete(id)
    }
  }

  return (
    <AdminLayoutIndex
      model="tag"
      title={
        <Heading>
          <span>{I18n.t('generic.tags')}</span>
          <Button small={true}>
            <a href="/admin/tags/new">{I18n.t('generic.create_new')}</a>
          </Button>
        </Heading>
      }
      main={
        <DraggableTable>
          <div className="Table">
            <div>
              <div className="Table_Row">
                <div className="Table_Header">{I18n.t('generic.id')}</div>
                <div className="Table_Header label">{I18n.t('generic.name')}</div>
                <div className="Table_Header label">{I18n.t('generic.name_ja')}</div>
                <div className="Table_Header label" />
                <div className="Table_Header handle" />
              </div>
            </div>
            <div>
              <Container onDrop={onDrop}>
                {tags.map((tag, index) => {
                  return (
                    <Draggable key={`category-${index}`}>
                      <div className="Table_Row">
                        <div className="Table_Data">{tag.id}</div>
                        <div className="Table_Data label">{tag.name}</div>
                        <div className="Table_Data label">{tag.name_ja}</div>
                        <div className="Table_Data">
                          <Button small={true}>
                            <a href={`/admin/tags/${tag.id}/edit`}>{I18n.t('generic.edit')}</a>
                          </Button>
                          <Button
                            small={true}
                            handleClick={() => {
                              handleClickDelete(tag.id)
                            }}
                          >
                            {I18n.t('generic.delete')}
                          </Button>
                        </div>
                        <div className="Table_Data handle">
                          <SvgIcon
                            name="drag_handle"
                            className="icon"
                            ariaHidden={true}
                            role="presentation"
                          />
                        </div>
                      </div>
                    </Draggable>
                  )
                })}
              </Container>
            </div>
          </div>
          <Button handleClick={onSubmit}>{I18n.t('generic.update_order')}</Button>
        </DraggableTable>
      }
    />
  )
}

const Heading = styled.div`
  .Button {
    margin-left: 12px;
  }
`

const DraggableTable = styled.div`
  .Table {
    display: table;
    margin-bottom: 20px;
    .Table_Header,
    .Table_Data {
      display: table-cell;
      max-width: 240px;
      width: 120px;
      height: 40px;
      padding: 4px 8px;
      vertical-align: middle;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      border-bottom: solid 1px ${constants.COLORS.divider};
      &.handle {
        cursor: grab;
        &:active {
          cursor: grabbing;
        }
      }
      > a {
        color: ${constants.COLORS.primary};
      }
      &.label {
        width: 240px;
      }
      &.handle {
        width: 40px;
        text-align: center;
      }
    }
  }
`
export default AdminTagIndex
